import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, SmartphoneIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { DECO_COOKIE, OFFER_SUMMARY } from './salesData';

/**
 * PRIMERA revelación del precio de toda la carta. El CTA del hero
 * PRIMERA aparición del precio y bloque principal de oferta. Todos los CTA
 * anteriores anclan exactamente acá (#oferta); a partir de este punto los
 * CTA ya pueden abrir el checkout.
 *
 * La card es deliberadamente compacta: precio en línea, beneficios en dos
 * columnas y el CTA a pocos píxeles del precio.
 */
export function OfferSection() {
  return <section id="oferta" className="relative scroll-mt-24 overflow-hidden bg-[#E9F0D5] py-12 sm:py-16" aria-labelledby="offer-title" data-id="element-255" data-mp="wd99xx8lzq52">
      <div className="relative mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-256" data-mp="2t7macftdl3c4">
        <div className="flex flex-col items-center text-center" data-id="element-257" data-mp="2y4mgeqq86638">
          <SectionTag className="bg-white/70" data-id="element-258" data-mp="12ns193d008wj">El precio</SectionTag>
          <h2 id="offer-title" className="mt-4 font-display text-[1.95rem] leading-[1.08] text-charcoal sm:text-[2.7rem]" data-id="element-259" data-mp="xws7u83388ys">
            100 recetas. Un solo pago.
          </h2>
        </div>

        <div className="relative mt-7 rounded-5xl bg-white p-5 shadow-bakery sm:mt-9 sm:p-8" data-id="element-260" data-mp="owwqtmmupjqu">
          {/* Cookie que rompe el borde superior de la card. */}
          <img src={DECO_COOKIE} alt="" aria-hidden loading="lazy" className="absolute -right-4 -top-7 h-[4.5rem] w-[4.5rem] rotate-6 rounded-full object-cover shadow-bakery sm:-right-8 sm:-top-10 sm:h-24 sm:w-24" data-id="element-261" data-mp="1lk0aei94t3x4" />

          <div className="flex flex-col items-center gap-2.5 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-262" data-mp="17opklj9qv8zm">
            <p className="max-w-sm font-display text-[1.08rem] leading-tight text-charcoal sm:text-[1.3rem]" data-id="element-263" data-mp="3scu25ywr0xqr">
              100 New York Cookies + 5 bonos
            </p>
            <div className="flex shrink-0 items-center gap-2" data-id="element-264" data-mp="3tusoqh3adnsm">
              <span className="rounded-full bg-charcoal px-3.5 py-1 font-sans text-[0.6rem] font-bold uppercase tracking-[0.1em] text-white sm:text-[0.66rem]" data-id="element-265" data-mp="2mn9rqlf9v6p">
                2 tomos
              </span>
              <span className="font-sans text-sm font-bold text-caramel" aria-hidden data-id="element-266" data-mp="3otvcel4yjnz1">
                +
              </span>
              <span className="rounded-full bg-[#F47A2A] px-3.5 py-1 font-sans text-[0.6rem] font-bold uppercase tracking-[0.1em] text-white sm:text-[0.66rem]" data-id="element-267" data-mp="3b26yccb5epff">
                5 bonos
              </span>
            </div>
          </div>

          <div className="mt-5 rounded-4xl bg-ivory px-4 py-5 sm:px-6" data-id="element-268" data-mp="3645g1tljqu50">
            <PriceBlock size="lg" data-id="element-269" data-mp="362cakhmo6fyl" />
          </div>

          <div className="mt-5 flex items-baseline gap-3" data-id="element-270" data-mp="2s4dy5hrwstlq">
            <p className="font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-[#F47A2A]" data-id="element-271" data-mp="2x3qtkqwuj8zx">
              Incluye
            </p>
            <span className="h-px flex-1 bg-warm" aria-hidden data-id="element-272" data-mp="2dizzb6vt3828" />
          </div>
          <ul className="mt-3 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-273" data-mp="28jdmuznsxvuh">
            {OFFER_SUMMARY.map(item => <li key={item} className="flex items-start gap-2" data-id="element-274" data-mp="2mjofa74rfihr">
                <span className="mt-[0.2rem] flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-pistacho" aria-hidden data-id="element-275" data-mp="2ih1n2546fvk1">
                  <CheckIcon className="h-2.5 w-2.5 text-white" data-id="element-276" data-mp="2weggdkxjwnha" />
                </span>
                <span className="font-sans text-[0.84rem] font-medium leading-snug text-charcoal/85" data-id="element-277" data-mp="2rflwefnuksvl">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-278" data-mp="319m8j1hjqydt">
            <CTAButton size="lg" className="w-full" data-id="element-279" data-mp="3f6rbutpvlj5d" />

            <ul className="mt-3.5 flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5" data-id="element-280" data-mp="3f7k9942y2wau">
              <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-281" data-mp="3aa0v0468yjiw">
                <LockIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-282" data-mp="18h7idcvnglka" /> Pago seguro
              </li>
              <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-283" data-mp="1i8tqh0coy4it">
                <ZapIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-284" data-mp="1ma6wpbjp49q9" /> Acceso inmediato
              </li>
              <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-285" data-mp="pkxvq16ommoo">
                <SmartphoneIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-286" data-mp="ukagmgdztjom" /> Producto
                digital
              </li>
              <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-287" data-mp="ymytr09qpcre">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-288" data-mp="2a018rqw6xu9g" /> Garantía de
                7 días
              </li>
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center font-sans text-[0.78rem] leading-relaxed text-charcoal-mid" data-id="element-289" data-mp="2f1713nlxvfig">
          Producto 100% digital: no se envía nada físico. Los resultados de venta dependen de la
          ejecución, la presentación y el mercado de cada persona.
        </p>
      </div>
    </section>;
}